var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashTurnOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35189 12L5.17642 15V20H10.8255V15L13.65 12V7H2.35189V12ZM4.23491 9H11.767V11.17L8.94245 14.17V18H7.05943V14.17L4.23491 11.17V9ZM7.05943 0H8.94245V3H7.05943V0ZM0 3.874L1.33129 2.46L3.32918 4.58L1.99788 5.995L0 3.874ZM12.6708 4.582L14.6696 2.462L16 3.878L14.0012 5.998L12.6708 4.582Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashTurnOn);
export default __webpack_public_path__ + "static/media/Flash-turn-on.2b12d22bc561556d3f3642f0125cf040.svg";
export { ForwardRef as ReactComponent };